import axios from 'axios'
import store from '../store/index'
import {API} from '../api'

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export class FFF_COM_VN {

  constructor() {
    this.lang = 'vi'
    this.country = 'vn'
  }

  async get_keyword_result(keywords = [], limit = 5000, base_keyword = '') {
    try {
      const form_data = {}
      form_data['keywords'] = keywords
      form_data['keyword'] = base_keyword

      let resp = await this.make_request({
        url: '',
        method: 'POST',
        form: form_data,
        lang: this.lang,
        country: this.country
      })

      if (!resp || !resp.data) {
        await sleep(3000)

        resp = await this.make_request({
          url: '',
          method: 'POST',
          form: form_data,
          lang: this.lang,
          country: this.country
        })
      }

      return resp && resp.data ? resp.data : null
    } catch (error) {
      console.log('keywords error:', error)
      return null
    }
  }

  async make_request(config) {
    return await axios.post(API.URL_API_SRV_2 + '/keyword/request_keyword', {config}, {headers: {'Authorization': store.state.userInfo.token}})
  }
}



// WEBPACK FOOTER //
// ./src/addon/fff.js